import { HttpState } from './../reducers/http.reducer';
import { CORE_FEATURE } from './../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCore from '@core/store/reducers';

export const getCoreState =
  createFeatureSelector<fromCore.CoreState>(CORE_FEATURE);

export const getHttpState = createSelector(getCoreState, (state) => state.http);

export const getHttp = createSelector(getHttpState, (http) => http.data);

export const getHttpLoading = createSelector(
  getHttpState,
  (http: HttpState) => http.loading
);

export const getHttpLoaded = createSelector(
  getHttpState,
  (http: HttpState) => http.loaded
);
